import Vue from 'vue';
import VueLocalStorage from 'vue-ls';
import VeeValidate from 'vee-validate';
import VueMeta from 'vue-meta';
import vClickOutside from 'v-click-outside';

import './styles/quasar.styl';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBtnGroup,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QField,
  QInput,
  QCheckbox,
  QImg,
  QDialog,
  QCard,
  QCardActions,
  QSpinnerGears,
  QAvatar,
  QTab,
  QTabs,
  QSeparator,
  QTabPanel,
  QTabPanels,
  QInnerLoading,
  QBadge,
  QTable,
  QMarkupTable,
  ClosePopup,
  Dialog,
  Loading,
  Notify,
} from 'quasar';

Notify.setDefaults({
  position: 'top',
  timeout: 4000,
});

Vue.use(VueLocalStorage);
Vue.use(VeeValidate, {
  events: 'blur',
});
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(vClickOutside);

Vue.use(Quasar, {
  config: {
    brand: {
      primary: '#288c53',
      secondary: '#c6935c',
      accent: '#9C27B0',

      positive: '#21BA45',
      negative: '#C10015',
      info: '#31CCEC',
      warning: '#F2C037',
    },
    loading: {
      spinner: QSpinnerGears,
      spinnerColor: 'green',
      messageColor: 'black',
      backgroundColor: 'white',
      message: 'Please, wait...',
    },
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QBtnGroup,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QField,
    QInput,
    QCheckbox,
    QImg,
    QDialog,
    QCard,
    QCardActions,
    QAvatar,
    QTab,
    QTabs,
    QSeparator,
    QTabPanel,
    QTabPanels,
    QSpinnerGears,
    QInnerLoading,
    QBadge,
    QTable,
    QMarkupTable,
  },
  directives: {
    ClosePopup,
  },
  plugins: {
    Dialog,
    Loading,
    Notify,
  },
});
